import type { ServerMeta } from "../types";

export function ServerStatusBar({ meta }: { meta: ServerMeta | null }) {
  if (!meta) return <span className="text-xs text-ink-500">连接中…</span>;
  return (
    <div className="flex items-center gap-2 text-xs text-ink-600">
      <span
        className={`chip ${
          meta.has_private_key ? "bg-emerald-100 text-emerald-800" : "bg-amber-100 text-amber-800"
        }`}
        title={meta.has_private_key ? "私钥就绪" : "私钥缺失：请先 avm-license keypair generate"}
      >
        私钥 {meta.has_private_key ? "✓" : "缺失"}
      </span>
      <span className="chip" title={meta.repo_root}>
        REPO_ROOT: <span className="truncate font-mono">{meta.repo_root.replace(/^.*\//, "…/")}</span>
      </span>
    </div>
  );
}
